<template>
    <div class="mt-3">
        <div class="w-full">
            <h1 class="text-3xl text-center">
                Configuraciones logísticas en total
                <strong class="text-theme-primary">
                    {{ itemsNumber }}
                </strong>
            </h1>
        </div>

        <div
            class="flex flex-col lg:flex-row items-center justify-between w-full mt-4 gap-4"
        >
            <div
                class="flex flex-wrap items-center justify-center lg:justify-start gap-2"
            >
                <tooltip-button
                    v-show="
                        selected.length &&
                        $ability.hasPermission('logisticConfiguration:Create')
                    "
                    icon="🗂️"
                    message="Clonar configuración logística"
                    @click="cloneSelected"
                />
            </div>

            <div
                class="flex flex-wrap items-center justify-center lg:justify-end gap-3"
            >
                <app-button relief @click="reloadItems">
                    Consultar 🔎
                </app-button>
                <custom-pagination
                    v-model="currentPage"
                    :length="pagesNumber"
                    @input="listItems()"
                />
                <tooltip-redirect
                    v-if="
                        $ability.hasPermission('logisticConfiguration:Create')
                    "
                    to="/app/logistic-configurations/new"
                    message="Nueva configuración logística"
                />
            </div>
        </div>

        <div class="w-full mt-4">
            <custom-table
                ref="selectableTable"
                :fields="$data.$fields"
                :items="itemsCurrent"
                :per-page="itemsCurrent.length"
                select-mode="single"
                selectable
                responsive
                outlined
                no-border-collapse
                hover
                class="w-full"
                items-empty-message="Nuestro sistema NO encuentra resultados. Intenta modificar los filtros de búsqueda."
                @flex-selected="onRowSelected"
            >
                <template #cell(slug)="data">
                    <router-link
                        :to="`/app/logistic-configurations/detail/${data.item.slug}`"
                        class="text-center btn btn-stack-primary p-1"
                    >
                        <div class="flex items-center">
                            <span>
                                {{ data.item.slug }}
                            </span>
                        </div>
                    </router-link>
                </template>
                <template #cell(name)="data">
                    <span class="text-center">
                        {{ data.item.name }}
                    </span>
                </template>
                <template #cell(updatedAt)="data">
                    <span class="text-center">
                        {{ data.item.updatedAt | date }}
                    </span>
                </template>
            </custom-table>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import CustomTable from "@/components/utils/CustomTable.vue";
import TooltipButton from "@/components/utils/TooltipButton.vue";
import TooltipRedirect from "@/components/utils/TooltipRedirect.vue";

export default {
    name: "SuppliersIndex",
    components: { TooltipRedirect, TooltipButton, CustomTable },
    layout: "app",
    data: () => ({
        itemsCurrent: [],
        selected: [],
        $fields: [
            { key: "slug", label: "Slug", sortable: false },
            { key: "name", label: "Nombre", sortable: true },
            { key: "updatedAt", label: "📆 Actualización", sortable: true }
        ],

        currentPage: 1,
        pagesNumber: 0,
        itemsNumber: 0
    }),
    computed: {
        ...mapGetters("control", ["backgroundColor"])
    },
    watch: {},
    async mounted() {
        const verifyPagePermission =
            this.$ability.verifyPagePermission.bind(this);
        await verifyPagePermission("logisticConfiguration:List", "/app");
        this.listItems(false);
    },
    methods: {
        ...mapActions("logisticConfigurations", [
            "listLogisticConfigurationsPaginated"
        ]),
        async listItems(complete = false) {
            this.isLoading = true;
            this.$loading.show();
            try {
                const { items, pagination } =
                    await this.listLogisticConfigurationsPaginated({
                        page: this.currentPage,
                        complete
                    });
                this.itemsCurrent = items;
                if (pagination) {
                    this.itemsNumber = pagination.itemsNumber;
                    this.pagesNumber = pagination.pagesNumber;
                }
                this.$loading.hide();
            } catch (error) {
                this.$loading.hide();
                this.isLoading = false;
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        async reloadItems() {
            this.currentPage = 1;
            await this.listItems(true);
        },
        onRowSelected(items) {
            this.selected = items;
        },
        clearSelected() {
            this.$refs.selectableTable.clearSelected();
            this.selected = [];
        },
        cloneSelected() {
            window
                .open(
                    `/app/logistic-configurations/clone/${this.selected[0].slug}`,
                    "_blank"
                )
                .focus();
        }
    }
};
</script>
